import React, { useEffect } from 'react';

/**
 * Health Check Page - Railway Health Monitor
 * 
 * Simple endpoint that Railway can ping to verify Vercel connectivity.
 * Returns JSON with status and timestamp.
 * 
 * This component handles both:
 * 1. API requests (fetch/curl) - Returns JSON via meta tag that can be parsed
 * 2. Browser requests - Shows a visual page
 */
const HealthCheckPage: React.FC = () => {
  const healthData = {
    status: 'ok',
    timestamp: new Date().toISOString(),
    service: 'vercel-frontend',
  };

  // For API clients, they can parse the JSON from the pre tag or use the data attribute
  useEffect(() => {
    // Set the document title to help with debugging
    document.title = 'Health Check - OK';
  }, []);

  return (
    <div style={{ 
      fontFamily: 'monospace', 
      padding: '20px',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <h1>🟢 Health Check</h1>
      <p>This endpoint is used by the Railway Health Monitor to verify connectivity.</p>
      
      {/* JSON data in a format that's easy to parse */}
      <div 
        id="health-data" 
        data-health={JSON.stringify(healthData)}
        style={{ display: 'none' }}
      >
        {JSON.stringify(healthData)}
      </div>
      
      {/* Visual display for browser access */}
      <pre style={{
        background: '#f5f5f5',
        padding: '15px',
        borderRadius: '5px',
        overflow: 'auto'
      }}>
        {JSON.stringify(healthData, null, 2)}
      </pre>
      <p style={{ color: '#666', fontSize: '14px' }}>
        Status: <strong style={{ color: '#16a34a' }}>Healthy</strong>
      </p>
      <p style={{ color: '#999', fontSize: '12px', marginTop: '40px' }}>
        Last updated: {new Date().toLocaleString()}
      </p>
    </div>
  );
};

export default HealthCheckPage;
